import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'e-payment-plan',
  templateUrl: './e-payment-plan.component.html',
  styleUrls: ['./e-payment-plan.component.scss']
})
export class EPaymentPlanComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
